import { jsxs as i, jsx as o } from "react/jsx-runtime";
import t from "styled-components";
import x from "../Icons/Alert.js";
import a from "../Icons/Info.js";
import e from "../../utils/colors.js";
import { device as p } from "../../utils/device.js";
const s = t.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: flex-start;
  min-width: auto;
  max-width: 500px;
  margin-top: 24px;

  @media ${p.isDesktop}, ${p.isTablet} {
    min-width: 335px;
  }

  ${(r) => r.type === "Error" ? "padding: 10px;" : `
    background-color: ${e.blueGrey75};
  `};
  border: ${(r) => r.type === "Error" ? `solid 3px ${e.red}` : "none"};
`, f = t.div`
  align-self: flex-start;
  padding-top: ${(r) => r.type === "Error" ? "10px" : "15px"};
  padding-left: 10px;
  padding-right: 10px;
  min-width: ${(r) => r.type === "Error" ? "29px" : "25px"};
  max-width: ${(r) => r.type === "Error" ? "29px" : "25px"};
  background-color: ${(r) => r.type === "Error" ? e.white : e.blueGrey75};
`, c = t.div`
  background-color: ${(r) => r.type === "Error" ? e.white : e.blueGrey10};
  color: ${(r) => r.type === "Error" ? e.red : e.blueGrey};
  flex-basis: 100%;
  padding: ${(r) => r.type === "Error" ? "10px 15px 0px" : "15px"};
  ${(r) => r.type === "Info" && "padding-left: 15px;"};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  overflow: hidden;
`, b = ({ type: r, children: d, textProps: n, ...l }) => /* @__PURE__ */ i(s, { type: r, ...l, children: [
  /* @__PURE__ */ i(f, { type: r, children: [
    r === "Error" && /* @__PURE__ */ o(x, { fill: e.red }),
    r === "Info" && /* @__PURE__ */ o(a, { fill: e.white })
  ] }),
  /* @__PURE__ */ o(c, { type: r, ...n, children: d })
] });
export {
  b as default
};
